import { isEmpty } from './index.utils'

const EMPTY_STR = '--'

// export const formatEmptyValue = (v, options = {}) => {
//   const { varNaN = false, emptyStr = EMPTY_STR } = options
//   if (isEmpty(v, varNaN)) {
//     return emptyStr
//   }
//   return v
// }

export const formatUnit = (v, unit = '', options = {}) => {
  const { varNaN = false, emptyStr = EMPTY_STR } = options
  if (isEmpty(v, varNaN)) {
    return emptyStr
  }
  return `${v}${unit}`
}

/**
 *  时间格式化
 */
export const formatDate = (v, format = 'YYYY-MM-DDTHH:mm:ss', options = {}) => {
  const { emptyStr = EMPTY_STR } = options
  if (isEmpty(v)) {
    return emptyStr
  }
  return moment(v).format(format)
}

/** 将度转换成为度分秒 */
export const formatDegree = (value, latlng, errMsg = EMPTY_STR) => {
  value = Number(value)
  if (isNaN(value) || !latlng) return errMsg
  let str = ''
  const isLat = latlng === 'lat'
  const isLng = latlng === 'lon' || latlng === 'lng'
  if (isLng && value > 180) {
    value = value - 360
  }
  if (value >= 0) {
    if (isLat) {
      str = 'N'
    }
    if (isLng) {
      str = 'E'
    }
  } else {
    if (isLat) {
      str = 'S'
    }
    if (isLng) {
      str = 'W'
    }
  }

  value = Math.abs(value)
  var v1 = Math.floor(value) // 度
  var v2 = Math.floor((value - v1) * 60) // 分
  var v3 = Math.round(((value - v1) * 3600) % 60) // 秒
  return v1 + '°' + v2 + "'" + v3 + '"' + str
}
